import { Container } from './SquareStyles';
import { REDCOLORSET } from '@/styles/colorTheme';

const Square = ({ stage = 0, sx }) => {
  return <Container style={{ ...sx }} backgroundColor={REDCOLORSET[stage]} />;
};

export default Square;
